import { GameManager } from "../GameManager";
import { GameVars } from "../GameVars";
import BattleUtils from "../gzp/BattleUtils";
import { BootScene } from "./BootScene";

export class PlayerInfoContainer extends Phaser.GameObjects.Container {

    public static currentInstance: PlayerInfoContainer;

    private gemsLabel: Phaser.GameObjects.Text;
    private textInputElement: Phaser.GameObjects.DOMElement;
    private nameLabel: Phaser.GameObjects.Text;
    private tapToChangeLabel: Phaser.GameObjects.Text;
    private gzpAvatar: Phaser.GameObjects.Image;
    constructor(scene: Phaser.Scene) {

        super(scene);
        if (!GameVars.playerData.name || BattleUtils.isBattle) 
        GameVars.playerData.name = BattleUtils.battlePlayerData.firstName;
        PlayerInfoContainer.currentInstance = this;
        console.log("PlayerInfoContainer", GameVars.playerData.name, BattleUtils.battlePlayerData.firstName, BattleUtils.battlePlayerData.photo);

        this.x = 75;
        this.y = 75 * GameVars.scaleY;

        this.scaleY = GameVars.scaleY;

        // const avatar = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "avatar-gamezop" + GameVars.playerData.avatarId);
        // this.add(avatar);

        this.gzpAvatar = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1",
            "avatar-gamezop-2");
        this.add(this.gzpAvatar);
        this.loadPlayerProfilePic();
        const frame = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "icon_frame");
        frame.setScale(1.075);
        this.add(frame);

        this.nameLabel = new Phaser.GameObjects.Text(this.scene, 65, -56 + (BootScene.textYgap * -130), GameVars.playerData.name, { fontFamily: "Teko-Medium", fontSize: "32px", color: "#FFFFFF" });
       if(BootScene._isWebKit) this.nameLabel.setOrigin(0, BootScene.originY);
        this.nameLabel.setShadow(0, 3 + (BootScene.textYgap * -128), "#061f55", 0, false, true);
        this.add(this.nameLabel);

        if (GameVars.currentScene.scene.key === "SplashScene") {

            this.scene.input.on("pointerdown", this.onDown, this);

            this.gzpAvatar.setInteractive();
            this.gzpAvatar.on("pointerdown", this.onDownName, this);

            this.nameLabel.setInteractive();
            this.nameLabel.on("pointerdown", this.onDownName, this);

            const gameText = this.scene.game.cache.json.get("game-text");

            let tapLabelText = this.scene.game.device.os.desktop ? gameText.CLICK_TO_CHANGE : gameText.TAP_TO_CHANGE;

            this.tapToChangeLabel = new Phaser.GameObjects.Text(this.scene, 65, -16 + (BootScene.textYgap * -105), tapLabelText, { fontFamily: "Teko-Medium", fontSize: "25px", color: "#CCCCCC" });
            if(BootScene.isWebKit)this.tapToChangeLabel.setOrigin(0, BootScene.originY);
            this.tapToChangeLabel.setShadow(0, 3 + (BootScene.textYgap * -118), "#061f55", 0, false, true);
            this.tapToChangeLabel.setInteractive();
            this.tapToChangeLabel.on("pointerdown", this.onDownName, this);
            this.add(this.tapToChangeLabel);

            this.textInputElement = this.scene.add.dom(315, 45 * GameVars.scaleY).createFromCache("nameform");
            this.textInputElement.visible = false;
            this.textInputElement.scaleY = GameVars.scaleY;

        } else {

            const gemIcon = new Phaser.GameObjects.Image(this.scene, 90, 16 + (BootScene.textYgap * 20), "texture_atlas_1", "icon_top_gems");
            gemIcon.setScale(.75);
            this.add(gemIcon);

            this.gemsLabel = new Phaser.GameObjects.Text(this.scene, 125, -7 + (BootScene.textYgap * -180), GameVars.formatNumber(GameVars.gameData.gems), { fontFamily: "Teko-Medium", fontSize: "42px", color: "#FFFFFF" });
            if(BootScene._isWebKit)this.gemsLabel.setOrigin(0, BootScene.originY);
            this.gemsLabel.setShadow(0, 3.5, "#061f55", 0, false, true);
            this.add(this.gemsLabel);
        }
    }

    public updateBalance(): void {

        this.gemsLabel.text = GameVars.formatNumber(GameVars.gameData.gems);
    }

    public onEnterDown(): void {

        const inputText = <any>this.textInputElement.getChildByName("nameField");

        if (inputText.value !== "") {

            this.nameLabel.text = inputText.value;
            this.nameLabel.visible = true;
            this.textInputElement.visible = false;
            this.tapToChangeLabel.visible = true;

            GameManager.onPlayerNameEdited(inputText.value);
        }
    }

    private onDownName(): void {

        this.scene.time.delayedCall(50, function (): void {

            this.nameLabel.visible = false;
            this.textInputElement.visible = true;
            this.tapToChangeLabel.visible = false;

            this.scene.time.delayedCall(50, function (): void {
                const inputText = document.getElementById("nameField");
                inputText.focus();
            }, null, this);
        }, null, this);
    }

    private onDown(pointer: Phaser.Input.Pointer): void {

        let clickInAvatar = false;

        if (pointer.x > 25 && pointer.x < 120 && pointer.y > 25 && pointer.y < 120) {
            clickInAvatar = true;
        }

        let clickInInputfield = false;

        if (pointer.x < 300 && pointer.y > 25 && pointer.y < 50) {
            clickInInputfield = true;
        }

        if (clickInAvatar || clickInInputfield || this.tapToChangeLabel.visible) {
            return;
        }

        const inputText = <any>this.textInputElement.getChildByName("nameField");
        if (inputText.value === "") {
            inputText.value = "enter your name";
        }

        this.nameLabel.text = inputText.value;
        this.nameLabel.visible = true;
        this.textInputElement.visible = false;
        this.tapToChangeLabel.visible = true;

        GameManager.onPlayerNameEdited(inputText.value);
    }

    private loadPlayerProfilePic() {
        if (!BattleUtils.battlePlayerData.photo) {
            console.warn("Profile picture not available, player");
            this.gzpAvatar.setTexture("texture_atlas_1", "avatar-gamezop-2");
            return;
        }
        const loader = new Phaser.Loader.LoaderPlugin(this.scene);
        const cachekey = "playercache" + Math.floor(Math.random() * 1000);
        loader.image(cachekey, BattleUtils.getValidLoadUrl(BattleUtils.battlePlayerData.photo));
        loader.once("filecomplete", (key) => {
            this.gzpAvatar.setTexture(cachekey);
            this.gzpAvatar.displayHeight = 100;
            this.gzpAvatar.displayWidth = 100;
        });
        loader.once("loaderror", (e) => {
            console.log("Image load error, fallback to defautl");
            this.gzpAvatar.setTexture("texture_atlas_1", "avatar-gamezop-2");
        });
        loader.crossOrigin = "anonymous";
        loader.start();
    }
}
